import { cva } from "./index.ts";

export const link = cva({
  base: "underline color-obsidian-600",
});
